module.exports = __webpack_public_path__ + "static/media/visa.d385d7ff.png";